export const PROJECT_PATH_FIELDS = [
  { key: "building_name", type: "building", label: "건물명" },
  { key: "floor", type: "floor", label: "층" },
  { key: "location", type: "location", label: "위치" },
  { key: "facility_name", type: "facility", label: "설비명" },
  { key: "part_name", type: "part", label: "부품명" },
];

export const emptyProjectPath = () => Object.fromEntries(PROJECT_PATH_FIELDS.map(({ key }) => [key, ""]));
export function normalizeProjectPaths(paths = []) {
  const seen = new Set();
  return paths.filter(path => {
    const field = PROJECT_PATH_FIELDS.find(item => item.type === path?._nodeType);
    return !field || String(path[field.key] ?? "").trim();
  }).map(path => Object.fromEntries(PROJECT_PATH_FIELDS.map(({ key }) => [key, String(path?.[key] ?? "").trim()])))
    .filter(path => {
      const key = JSON.stringify(path);
      if (!Object.values(path).some(Boolean) || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
}

// Include every node, not just leaves: files may belong to a building or floor alone.
export function projectNodePaths(nodes = []) {
  const byId = new Map(nodes.map(node => [node.id, node]));
  return nodes.flatMap(node => {
    const path = { ...emptyProjectPath(), id: node.id };
    const seen = new Set();
    let current = node;
    let childDepth = PROJECT_PATH_FIELDS.length;
    while (current) {
      const nodeType = current.node_type;
      const depth = PROJECT_PATH_FIELDS.findIndex(field => field.type === nodeType);
      if (depth < 0 || depth >= childDepth || seen.has(current.id) || !current.name || current.project_id !== node.project_id) return [];
      seen.add(current.id);
      path[PROJECT_PATH_FIELDS[depth].key] = current.name;
      childDepth = depth;
      if (!current.parent_id) break;
      current = byId.get(current.parent_id);
      if (!current) return [];
    }
    return [path];
  }).sort((a, b) => projectPathLabel(a).localeCompare(projectPathLabel(b), "ko", { numeric: true }));
}

export function projectPathLabel(path) {
  const values = PROJECT_PATH_FIELDS.map(({ key }) => path[key] || "미지정");
  while (values.length > 1 && values[values.length - 1] === "미지정") values.pop();
  return values.join(" › ");
}
